<template>
  <el-dialog
    :visible.sync="visible"
    class="editDialog screenDialog"
    title="实时数据"
    :close-on-click-modal="false"
    width="40%"
  >
    <div id="actualChart" ref="actualChart" v-if="isHasData"></div>
  </el-dialog>
</template>

<script>
  import { getChartFontSize } from '@/utils'
  export default {
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      value: {
        type: Boolean,
        default: false
      },
      line: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        visible: this.value,
        myChart: undefined,
        resizeHandler: null,
        chartData: {
          xAxis: [],
          yAxis: []
        },
        timer: null,
        isHasData: false
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      this.resizeHandler = _ => {
        this.debounceResize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    watch: {
      value(val) {
        this.setCurrentValue(val)
      },
      visible(value) {
        this.$emit('input', value)
      }
    },
    destroyed() {
      if (this.myChart) this.myChart.dispose()
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      if (this.debounceResize && this.debounceResize.cancel) {
        this.debounceResize.cancel()
      }
      // 清除定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    methods: {
      setCurrentValue(val) {
        this.visible = val
        if (val) {
          this.getData()
          // 确保只有一个定时器在运行
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.getData()
            }, 30000)
          }
        } else {
          // 当visible为false时停止定时器
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
        }
      },
      getData() {
        let data = {}
        if (this.type == 'scope' || this.type == 'frequency') {
          data = {
            deviceId: this.data.deviceId,
            dataFlag: this.type
          }
        } else {
          data = {
            deviceId: this.data.deviceId,
            line: this.line,
            dataFlag: this.type
          }
        }
        this.$axiosget('operation/gapStick/todayAllData', {
          params: data
        }).then(res => {
          if (res.data.status == 10000) {
            if (res.data.data.length > 0) {
              this.isHasData = true
              this.chartData = {
                xAxis: res.data.data.map(item => item.sendTime),
                yAxis: res.data.data.map(item => {
                  if (!item.value && item.value !== 0) return 0
                  const valueStr = String(item.value)
                  const numMatch = valueStr.match(/^[\d.]+/)
                  return numMatch ? parseFloat(numMatch[0]) : 0
                })
              }
              this.$nextTick(() => {
                this.initEchart()
              })
            } else {
              this.isHasData = false
              this.chartData = {
                xAxis: [],
                yAxis: []
              }
            }
          }
        })
      },
      resize() {
        try {
          this.myChart.resize()
        } catch (e) {
          console.log(e)
        }
      },
      initEchart() {
        if (this.myChart) this.myChart.dispose()
        let dom = this.$refs.actualChart
        let myChart = this.$echarts.init(dom)
        setInterval(() => {
          if (dom.clientHeight !== 0) {
            myChart.resize()
          }
        }, 200)
        this.myChart = myChart
        this.myChart.setOption(this.getOption())
      },
      getOption() {
        let option
        option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: '#1e4291',
            borderWidth: 0,
            textStyle: {
              color: '#e3e3e3'
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                type: 'dashed',
                color: '#596e90'
              }
            }
          },
          legend: {
            show: false
          },
          grid: {
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.chartData.xAxis,
              axisLabel: {
                rotate: 40,
                color: '#f8f8f8',
                fontSize: getChartFontSize(12)
              },
              axisLine: {
                lineStyle: {
                  color: '#8da4ba'
                }
              },
              axisTick: {
                show: false
              }
            }
          ],
          yAxis: [
            {
              show: true,
              type: 'value',
              min: 0,
              splitLine: {
                show: true, //是否显示网格
                lineStyle: {
                  type: 'dashed',
                  color: 'rgb(72, 122, 169)'
                }
              },
              axisLabel: {
                color: '#cecece',
                fontSize: getChartFontSize(12)
              },
              axisLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: '实时数据',
              type: 'line',
              stack: 'undeal',
              smooth: true,
              showSymbol: false,
              symbol: 'circle',
              symbolSize: 10,
              color: '#377aff',
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#214ea8'
                  },
                  {
                    offset: 1,
                    color: 'rgb(25, 55, 114)'
                  }
                ])
              },
              data: this.chartData && this.chartData.yAxis
            }
          ]
        }
        return option
      },
      refresh() {
        this.myChart.clear()
        this.myChart.setOption(this.getOption())
      }
    }
  }
</script>

<style lang="less" scoped>
  .screenDialog {
    /deep/ .el-dialog {
      padding-top: 20px;
      background: rgba(0, 42, 110, 0.8);
      border: none;

      .el-dialog__header {
        border-bottom-color: #3b4c75;
      }

      .el-dialog__body {
        padding-top: 10px;
      }
    }
  }

  #actualChart {
    width: 100%;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/actualData.vue